import React, { useEffect, useRef, useState } from "react";
import "./styles.css";
import { ReactTable } from "../../Molecules";
import { SUB_USER_VEHICLE_HEADERS } from "../../../Library/tableHeaders";
import { Link, useSearchParams } from "react-router-dom";
import PATHS from "../../../Routes/paths";

const RealtimeVehicleStatusTable = ({ vehicles }) => {
  const [ subUserVehs, setSubUserVehs ] = useState([]);
  const lastSeenFetchedOnce = useRef(false);
  const [ searchParams ] = useSearchParams();

  const handleLastSeen = (data) => {
    data.forEach(lastSeen => {
      let veh = subUserVehs.findIndex(veh => veh.idx === lastSeen.vid);
      if (veh !== -1) {
        let newVehData = { ...subUserVehs[veh], ignition: !lastSeen.ignition ? "OFF" : "ON", spd: lastSeen.spd };
        if (!lastSeen.mainPower && ((lastSeen.temp && !lastSeen.heartbeat) || (lastSeen.heartbeat && lastSeen.heartbeat.mainPower === false))) newVehData.status = "Disconnected";
        else if ((!lastSeen.motion && !lastSeen.heartbeat) || (lastSeen.heartbeat && !lastSeen.ignition)) newVehData.status = "Idle";
        else newVehData.status = "Running";

        subUserVehs[veh] = newVehData;
        setSubUserVehs([ ...subUserVehs ]);
      }
    });

    let action = global.EE.EVENT_TYPES.SUBSCRIBE_TO_VEHICLES;
    let vehs = { veh: vehicles.map(veh => veh.idx) };
    if (global.WS && global.WS.wsConnected) global.WS.sendRequest({ action, data: vehs });
  }

  const handleRealTimeData = (data) => {
    if (data && data.vid) {
      let vehicle = subUserVehs.findIndex(veh => veh.idx === data.vid);
      if (vehicle !== -1) {
        let newVehData = { ...subUserVehs[vehicle], ignition: data.ignition ? "ON" : "OFF", spd: data.spd };
        if (!data.mainPower && ((data.temp && !data.heartbeat) || (data.heartbeat && data.heartbeat.mainPower === false))) newVehData.status = "Disconnected";
        else if ((!data.motion && !data.heartbeat) || (data.heartbeat && !data.ignition)) newVehData.status = "Idle";
        else newVehData.status = "Running";

        subUserVehs[vehicle] = newVehData;
        setSubUserVehs([ ...subUserVehs ]);
      }
    }
  }

  const handleVehicles = () => {
    if (vehicles && vehicles.length) {
      setSubUserVehs(vehicles);
      let action = "getDynamicLastSeen";
      let data = { vids: vehicles.map(veh => veh.idx) };
      if (global.WS && global.WS.wsConnected) global.WS.sendRequest({ action, data });
    }
  }

  useEffect(() => {
    if (vehicles && vehicles.length && !lastSeenFetchedOnce.current) {
      lastSeenFetchedOnce.current = true;
      handleVehicles();
    }
  }, [ vehicles, subUserVehs ]);


  useEffect(() => {
    global.EE.addEventListener(global.EE.EVENT_TYPES.ON_LAST_SEEN, handleLastSeen);
    global.EE.addEventListener(global.EE.EVENT_TYPES.RT_LOC_EVT, handleRealTimeData);
    global.EE.addEventListener(global.EE.EVENT_TYPES.WS_CONNECTED, handleVehicles);

    return () => {
      global.EE.removeEventListener(global.EE.EVENT_TYPES.ON_LAST_SEEN, handleLastSeen);
      global.EE.removeEventListener(global.EE.EVENT_TYPES.RT_LOC_EVT, handleRealTimeData);
      global.EE.removeEventListener(global.EE.EVENT_TYPES.WS_CONNECTED, handleVehicles);
    }
  }, [ vehicles, subUserVehs ]);

  const columns = React.useMemo(() => Object.values(SUB_USER_VEHICLE_HEADERS).map(header => {
    return {
      Header: header.nm,
      accessor: header.key,
      disableSortBy: !header.sorting,
      Cell: (row) => {
        if (row.column.id === "reg") {
          return <Link className="subuser-vehicle-name" to={`${PATHS.LIVE_TRACKING}/${PATHS.VEHICLE_STATS}?idx=${row.row.original.idx}&lt=true&assigned=${searchParams.get("mob")}`}>{row.value || "-"}</Link>
        }

        return row.value || "-";
      }
    };
  }), []);

  return (
    <div className="realtime-vehicle-status-table">
      <ReactTable
        columns={columns}
        data={subUserVehs}
        showSearch={true}
        pageSize={10}
      />
    </div>
  )
}

export default RealtimeVehicleStatusTable
